export default {"src":"/_next/static/media/portfolio-catapult-header-icon-light-theme.55e3ebcd.svg","height":58,"width":58};